import { HStack, Text, VStack } from "@chakra-ui/react";
import React, { useContext } from "react";

import { Button } from "../../../components";
import {
  AiInterviewerWizardContext,
  WizardStep,
} from "./AiInterviewerWizardContext";

interface AiInterviewerWizardControlsProps {
  steps: WizardStep[];
  currentStep: number;
  readOnly?: boolean;
}

const AiInterviewerWizardControls: React.FC<
  AiInterviewerWizardControlsProps
> = ({ steps, currentStep, readOnly }) => {
  const { subStepDisplay } = useContext(AiInterviewerWizardContext);

  if (currentStep < 0 || currentStep >= steps.length) {
    return null;
  }
  const step = steps[currentStep];

  const header = subStepDisplay?.header ?? step.header;
  const description = subStepDisplay?.description ?? step.description;
  const onNext = subStepDisplay?.onNext ?? step.onNext;
  const onBack = subStepDisplay?.onBack ?? step.onBack;
  const nextLabel =
    subStepDisplay?.nextLabel ??
    (currentStep < steps.length - 1 ? "Next" : "Done");

  return (
    <HStack
      pt="3"
      px="5"
      pb="4"
      spacing="6"
      bg="whiteAlpha.300"
      borderRadius="xl"
    >
      <VStack color="white" spacing="2" alignItems="start">
        <Text fontSize="lg" fontWeight="semibold">
          {header}
        </Text>
        <Text fontSize="md">{description}</Text>
      </VStack>
      <HStack spacing="6">
        {onBack && (
          <Button
            onClick={onBack}
            variant="unstyled"
            color="white"
            isDisabled={readOnly}
          >
            Back
          </Button>
        )}
        {onNext && (
          <Button onClick={onNext} colorScheme="blue" isDisabled={readOnly}>
            {nextLabel}
          </Button>
        )}
      </HStack>
    </HStack>
  );
};

export default AiInterviewerWizardControls;
